<section class="page-shell">
  <header class="page-header">
    <h4>Recueil inter-consultants ({{ page()?.totalCount ?? 0 }})</h4>

    <div class="page-header-actions">
      <oui-button
        iconSuffix="download"
        (click)="exportCsv()"
        [disabled]="exporting() || loading()">
        Export CSV
      </oui-button>
      <oui-button
        color="secondary"
        type="outlined"
        iconSuffix="sync"
        (click)="reload()"
        [disabled]="loading()">
        Recharger
      </oui-button>
    </div>
  </header>

  @if (error() && !loading()) {
    <dbw-state-card
      appearance="error"
      title="Chargement impossible">
      <p>{{ error() }}</p>
    </dbw-state-card>
  }

  <section class="content-grid">
    <article class="panel dbw-card dbw-card--xl">
      <div class="panel-heading">
        <div>
          <h4>Recueils à inspecter</h4>
          <p>{{ page()?.totalCount ?? 0 }} recueil(s) partagé(s) entre plusieurs consultants.</p>
        </div>
      </div>

      @if (!loading() && !error() && (page()?.items?.length ?? 0) === 0) {
        <div class="empty-state">Aucun recueil inter-consultants détecté.</div>
      }

      @if (loading()) {
        <dbw-state-card
          appearance="loading"
          [compact]="true">
          <p>Chargement du reporting recueil en cours.</p>
        </dbw-state-card>
      }

      @if (!loading() && (page()?.items?.length ?? 0) > 0) {
        <div class="table-shell">
          <oui-table
            class="data-table"
            [lineSizing]="'dense'">
            <table
              mat-table
              [dataSource]="page()?.items ?? []">
              <ng-container matColumnDef="recueil">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Recueil
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <div class="content-short">
                    <strong>
                      <a
                        [routerLink]="appRoutePaths.minotaure.metadata(row.metadataId)"
                        target="_blank"
                        rel="noopener">
                        {{ getRecueilTitle(row) }}
                      </a>
                    </strong>
                    <div>{{ row.recueilObjects.length }} élément(s) à inspecter</div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="investors">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Investisseurs
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <div class="card-list">
                    @for (investor of getInvestors(row); track investor.investorId) {
                      <dbw-investor-card
                        [id]="investor.investorId"
                        [code]="investor.investorCode || '-'"
                        [name]="investor.displayName"
                        [statusCode]="investor.statusCode"></dbw-investor-card>
                    }
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="consultants">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Consultants
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <div class="card-list">
                    @for (consultant of getConsultants(row); track consultant.key) {
                      <dbw-consultant-card
                        [id]="consultant.consultantId"
                        [code]="consultant.consultantCode || '-'"
                        [name]="consultant.consultantName || '-'"
                        [statusCode]="consultant.consultantStatusCode"></dbw-consultant-card>
                    }
                  </div>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns; trackBy: trackRow"></tr>
            </table>
          </oui-table>

          <mat-paginator
            [length]="page()?.totalCount ?? 0"
            [pageIndex]="page()?.pageIndex ?? pageIndex()"
            [pageSize]="page()?.pageSize ?? pageSize()"
            [pageSizeOptions]="pageSizeOptions"
            [showFirstLastButtons]="true"
            (page)="onPageChange($event)">
          </mat-paginator>
        </div>
      }
    </article>
  </section>
</section>
